import BaseModel from '../core/BaseModel'
export default class WarrantyRepairProcessModel extends BaseModel {
    constructor() {
        super({
                name: "warranty_repair_process",
                tableName: 'core_warranty_repair_process'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                process_status: {
                    name: 'process_status',
                    label: 'Tiến độ thực hiện',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    sortable: true,
                    display: false,
                    options: [{ value: 0, label: 'Gửi yêu cầu', style: 'color: #CC0000; font-weight: 500;'}, { value: 1, label: 'Chờ tiếp nhận', style: 'color: #990099; font-weight: 500;'}, { value: 2, label: 'Chờ thực hiện', style: 'color: #0066FF; font-weight: 500;'}, { value: 3, label: 'Chờ giao trả', style: 'color: #FF6600;font-weight: 500;'}, { value: 4, label: 'Hoàn thành', style: 'color: #009900;font-weight: 500;'}],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
            },)
    }
}